import { MInvoicePayment } from '@Models/client/my-account.model'

// models section
interface ITotalTableProps {
    data: MInvoicePayment
}

function TableTotal(props: ITotalTableProps) {
    // core section
    const { data } = props

    // main
    return (
        <dl
            style={{ width: '500px' }}
            className="ml-auto total-info text-right mt-3"
        >
            <dt>Payment Serial:</dt>
            <dd>{data?.serial}</dd>
            <br />
            <dt>Transaction:</dt>
            <dd>{data?.transaction}</dd>
            <br />
            <dt>Payment Method:</dt>
            <dd>{data?.method}</dd>
            <br />
            <dt>Amount:</dt>
            <dd>{data?.amount}</dd>
            <br />
            <dt>
                {' '}
                <span style={{ opacity: 0 }}>Paid Amount</span>
            </dt>
            <dd>-{data?.paidAmount}</dd>
            <br />
            <dt>Balance:</dt>
            <dd>{data?.balance}</dd>
        </dl>
    )
}

export default TableTotal
